
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/current-member-sms",
      function () {
        return require("private-next-pages/current-member-sms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/current-member-sms"])
      });
    }
  